module.exports = __webpack_public_path__ + "web/img/speech2.f1e9d973.png";